module.exports = {"653226100":"木尕拉镇","653226101":"先拜巴扎镇","653226200":"加依乡","653226201":"科克亚乡","653226202":"阿热勒乡","653226203":"阿日希乡","653226204":"兰干乡","653226205":"斯也克乡","653226206":"托格日尕孜乡","653226207":"喀拉克尔乡","653226208":"奥依托格拉克乡","653226209":"阿羌乡","653226210":"英巴格乡","653226211":"希吾勒乡","653226212":"达里雅布依乡","653226400":"拉依苏良种场","653226401":"国营（昆仑）种羊场","653226402":"于田监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653226.json
// module id = 2906
// module chunks = 0